<div class="contactus-container">
    <div fxLayout="row wrap" fxLayoutWrap fxLayout.lt-md="column wrap" fxLayoutGap="16px">
        <div fxFlex fxLayoutWrap >
            <mat-card class="csp1">
                <mat-card-title [ngClass]="color" [ngStyle]="{ 'border-bottom': btBorder }">
                    <h4 class="csp2">
                        Investment Manager
                    </h4>
                </mat-card-title>
                <mat-card-content class="csp3">
                   
                    <div *ngIf="nisusfin3">
                        <div *ngFor="let contact of contactdetails" class="csp4">
                            <span>{{contact.AMC_NAME}},</span> <br>
                            <span>{{contact.ADDRESS_LINE1}},</span> <br>
                            <span>{{contact.ADDRESS_LINE3}},</span> <br>
                            <span> Telephone :  {{contact.MOBILE_NUMBER}}</span> <br>
                            <span>Email : {{contact.EMAIL}}
                            </span>
                    </div>
                    </div>
                      <div  *ngIf="oldBridge" class="csp4">
                    <span>Old Bridge Capital Management Private Limited,</span> <br>
                    <span>103, Keshava, E-Block, BKC, Mumbai - 400051,</span> <br>
                    <span> Telephone: +91 22 62449122,</span> <br>
                    <!-- <span> Bandra East, Mumbai - 400 051,</span> <br> -->
                    <span>Email : investorservices&#64;oldbridgecapital.com</span>
                    <!-- <span>Email : operations@vishuddhacapital.com</span> -->
            </div>
                    <div  *ngIf="kotak1" class="csp4">
                        <span>Kotak Investment Advisors Limited,</span> <br>
                        <span>27 BKC, 7th Floor, Plot No:C-27, G-Block,</span> <br>
                        <span>Bandra Kurla Complex, Bandra E,</span> <br>
                        <span>Mumbai - 400051,</span> <br>
                        <span>Email : ir.optimus&#64;kotak.com</span><br>
                        <span>Phone : 022-43360000</span>
                </div>
                <div  *ngIf="heliosshow" class="csp4">
                    <span>Helios Capital Management (India) Private Limited,</span> <br>
                    <span>The Capital, 515A 5th Floor, Plot C70,</span> <br>
                    <span> Bandra Kurla Complex,</span> <br>
                    <span> Mumbai - 51,</span> <br>
                    <span>Phone: +91-22-6731 9600</span>
                    <!-- <span>Email : operations@vishuddhacapital.com</span> -->
            </div>
                <div *ngIf="kotakAlternate" class="csp4">
                    <span>Kotak Investment Advisors Limited, </span> <br>
                    <span>27 BKC, 7th Floor, Plot No:C-27, G-Block,</span> <br>
                    <span>Bandra Kurla Complex, Bandra E,</span> <br>
                    <span>Mumbai - 400051,</span> <br>
                    <span>Email : irteam&#64;kotak.com</span><br>
                    <span>Phone : 022-43360000</span>
                </div>
                <div  *ngIf="iifl" class="csp4">
                    <span>No: 158, Rayala Towers Tower 1,</span> <br>
                        <span>Ground Floor, Anna Salai,</span> <br>
                        <span>Chennai, Tamil Nadu - 600002</span> 
            </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div fxFlex fxLayoutWrap>
            <mat-card class="csp1">
                <mat-card-title [ngClass]="color" [ngStyle]="{ 'border-bottom': btBorder }">
                    <h4 class="csp2">
                        Service Provider
                    </h4>
                </mat-card-title>
                <mat-card-content class="csp3">
                    <div *ngIf="nisusfin3">
                        <div  *ngFor="let contact of contactdetails" class="csp4">
                            <!-- <span>{{contact.SERVICE_NAME}}, </span> <br>
                            <span>{{contact.SERVICE_ADDRESS}}.</span> <br> -->
                            <span>{{address1}}</span><br>
                            <span>{{address2}}</span><br>
                            <span>{{address4}}</span><br>
                            <span>{{address5}}</span><br>
                        </div>
                    </div>
                    <div  *ngIf="oldBridge" class="csp4">
                        <span>No. 158, Rayala Tower, Tower 1, 1st Floor,</span> <br>
                        <span>Anna Salai, Chennai - 600002,</span> <br>
                        <span>Telephone: +91 44 61092679</span> <br>
                        <!-- <span> Mobile:  044-61092499 </span> <br> -->
                        <span>Email : oldbridge&#64;camsonline.com</span>
                    </div>
                    <div *ngIf="kotak1" class="csp4">
                        <span>Computer Age Management Services Ltd,</span> <br>
                        <span>No. 158, Anna Salai, Rayala Tower,</span> <br>
                        <span>Tower 1, 1st Floor,Chennai - 600002,</span> <br>
                        <span> Phone :  044-61092610 </span> <br>
                        <span>Email :  kotakaif&#64;camsonline.com </span>
                    </div>
                    <div  *ngIf="heliosshow" class="csp4">
                        <span>Computer Age Management Services Ltd,</span> <br>
                        <span> Unit : AIF / PE & VC Fund </span> <br>
                        <span>No. 158, Rayala Towers, Tower - 3, 2nd Floor,</span> <br>
                        <span>Anna Salai, Chennai - 600002,</span> <br>
                        <span>Phone: 044 61093434,</span> <br>
                        <span>E mail: helioscapital&#64;camsonline.com</span> 
                    </div>
                    <div *ngIf="kotakAlternate" class="csp4">
                        <span>Computer Age Management Services Ltd,</span> <br>
                        <span>No. 158, Anna Salai, Rayala Tower,</span> <br>
                        <span>Tower 1, 1st Floor,Chennai - 600002,</span> <br>
                        <span> Phone :  044 61092499 </span> <br>
                        <span>Email :  IWFII&#64;camsonline.com </span>
                    </div>
                    <div  *ngIf="iifl" class="csp4">
                        <span>No: 158, Rayala Towers Tower 1,</span> <br>
                        <span>Ground Floor, Anna Salai,</span> <br>
                        <span>Chennai, Tamil Nadu - 600002</span> 
                </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>